import { useDataset } from "../../../contexts/DatasetContext";
import { ConfirmModal } from "../../../components/modals/ConfirmModal";

export const AnnotationDiscardChangesModal = () => {
  const { isDiscardChangesModalOpen, confirmDiscardChanges, cancelDiscardChanges } = useDataset();

  return (
    <ConfirmModal
      isOpen={isDiscardChangesModalOpen}
      setIsOpen={(isOpen) => !isOpen && cancelDiscardChanges()}
      title="Abandonner les modifications ?"
      text="Les modifications apportées à cette image ne seront pas enregistrées."
      onConfirm={confirmDiscardChanges}
    />
  );
};